<template>
  <div class="login wrapper fadeInDown">
    <div id="formContent">
      <!-- Icon -->
      <div class="fadeIn first">
        <img
          :src="
            setting_image && setting_image.logo_sgv && setting_image.logo_sgv.value ?
            setting_image.logo_sgv.value : '/img/brand/top-logo.png'
          "
          style="width: 50%; margin-top: 2vh;"
          id="icon"
          alt="User Icon"
        />
        <br />
        <br />
        <span class="h3">SISTEMA DE GERENCIAMENTO DE</span>
        <br />
        <span class="h3">VENDAS</span>
      </div>

      <form class="form-signin" @submit.prevent="sendEmail">
        <div></div>
        <div class="form-group">
            <div class="form-group">
                <input
                    v-model="email"
                    type="email"
                    class="form-control fadeIn third"
                    id="email"
                    placeholder="Email"
                    @input="checkValidEmail"
                />
            </div>
            <div v-if="showEmptyEmailError" class="text-danger">O campo email não pode estar vazio!</div>
            <div v-if="showEmailError" class="text-danger">Digite um email válido.</div>
            
        </div>
        <button class="btn btn-info mb-3 fadeIn fourth" @click.prevent="sendEmail">Enviar Email de Recuperação</button>
        <div id="formFooter">
          <a class="underlineHover" href="/login">Login</a>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ForgetPassword",
  data() {
    return {
      email: "",
      showEmptyEmailError: false,
      showEmailError: false
    }
  },
  methods: {
    checkValidEmail() {
      this.showEmptyEmailError = this.email.length == 0;
      this.showEmailError = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
    },
    sendEmail() {
      this.checkValidEmail()
      
      if(!this.isEmailValid) return;
      
      this.$http.secured
      .post(`/api/v1/reset_password`, {email: this.email})
        .then(response => { 
          this.$toasted.global.defaultSuccess({msg: 'E-mail de verificação encaminhado !'});
          this.$router.push('/login')
        })
        .catch(error => { 
          if(error.response.status >= 500 && error.response.status <= 599) 
            this.$toasted.global.defaultError({msg: 'E-mail não encontrado, contate a equipe técnica'});
          else if(error.response.status >= 400 && error.response.status <= 499)
            this.$toasted.global.defaultError({msg: 'E-mail não encontrado, contate a equipe técnica !'});
        })
    },
  },
  computed: {
    isEmailValid() {
      return (
        !this.showEmptyEmailError &&
        !this.showEmailError
      );
    },
    setting_image() {
      return this.$store.state.imageSettings || {}
    }
  },
}

</script>

<style lang="css">
.login .form-signin {
  width: 90%;
  max-width: 500px;
  padding: 10% 15px;
  margin: 0 auto;
}

/* BASIC */

html {
  background-color: rgb(23, 43, 77);
}

body .login {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

.login a {
  color: #92badd;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

.login h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
}

/* STRUCTURE */

.login.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.login #formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  margin-top: 100px;
  box-shadow: 0 20px 20px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
}

/* ANIMATIONS */

/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.fadeIn {
  opacity: 0;
  -webkit-animation: fadeIn ease-in 1;
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;

  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;

  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  animation-duration: 1s;
}

.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

h1 {
  color: #60a0ff;
}

@media (max-width: 768px) {
  .login .form-signin {
    width: 90%;     
  }
  .login.wrapper {
    margin-top: 30px;
  }
}
</style>